import * as React from "react";
import { Spinner, SpinnerSize } from "@fluentui/react";
import OfficeAddinMessageBar from "./OfficeAddinMessageBar";
import Welcome from "./Welcome";
import { HeroListItem } from "./HeroList";
import { signInSF } from "../../../utilities/sflogin";
import Dashboard from "./Dashboard";
import Progress from "./Progress";

/* global require console */

export interface AppProps {
  title: string;
  isOfficeInitialized: boolean;
  LoggedIn: boolean;
}

export interface AppState {
  authStatus?: string;
  fileFetch?: string;
  headerMessage?: string;
  errorMessage?: string;
  loginurl?: string;
  enableai?: boolean;
}

export default class App extends React.Component<AppProps, AppState> {
  constructor(props, context) {
    super(props, context);
    this.state = {
      authStatus: "notLoggedIn",
      fileFetch: "notFetched",
      headerMessage: "Welcome",
      errorMessage: "",
      loginurl: "",
      enableai: true,
    };
    this.boundSetState = this.setState.bind(this);
    this.setToken = this.setToken.bind(this);
    this.displayError = this.displayError.bind(this);
    this.login = this.login.bind(this);
    this.setLoginUrl = this.setLoginUrl.bind(this);
    this.setLogoutstatus = this.setLogoutstatus.bind(this);
  }

  accessToken: string;

  listItems: HeroListItem[] = [
    {
      icon: "PlugConnected",
      primaryText:
        "Accordor Template AI to easy design, streamline and automate expertise Salesforce CLM templates without coding or knowledge, ultimately leading to more efficient contract lifecycle management process.",
    },
  ];

  /*
    Methods
  */
  errorDismissed = () => {
    this.setState({ errorMessage: "" });

    // If the error occured during a "in process" phase (logging in or getting files),
    // the action didn't complete, so return the UI to the preceding state/view.
    this.setState((prevState) => {
      if (prevState.authStatus === "loginInProcess") {
        return { authStatus: "notLoggedIn" };
      } else if (prevState.fileFetch === "fetchInProcess") {
        return { fileFetch: "notFetched" };
      }
      return null;
    });
  };

  boundSetState: () => {};

  setLogoutstatus = () => {
    console.log("called logout module....");
    this.setState({ authStatus: "notLoggedIn", headerMessage: "Welcome" });
  };

  setenableai = (valenable: boolean) => {
    this.setState({ enableai: valenable });
  };

  setToken = (accesstoken: string) => {
    this.accessToken = accesstoken;
  };

  displayError = (error: string) => {
    this.setState({ errorMessage: error });
  };

  setLoginUrl = (loginmode: string) => {
    this.setState({ loginurl: loginmode });
  };

  login = async () => {
    if (this.state.loginurl == "Custom") {
      this.displayError("Please enter custom sandbox URL");
    } else {
      await signInSF(this.boundSetState, this.setToken, this.displayError, this.state.loginurl);
    }
  };

  render() {
    console.log(this.props);
    const { title, isOfficeInitialized, LoggedIn } = this.props;

    if (!isOfficeInitialized) {
      return (
        <Progress
          title={title}
          logo={require("../components/../../../assets/logo-filled.png")}
          message="Please wait loading...."
        />
      );
    }

    let body;
    console.log("Props states");
    console.log(LoggedIn);
    console.log("Props Enable....");
    console.log(this.state.enableai);
    if (this.state.authStatus === "notLoggedIn" && !LoggedIn) {
      body = (
        <Welcome
          login={this.login}
          logo={require("../../../assets/logo-filled.png")}
          message="Template AI Designer"
          title="Accordor"
          loginurl={this.setLoginUrl}
        />
      );
    } else if (this.state.authStatus === "loginInProcess" && !LoggedIn) {
      body = <Spinner className="spinner" size={SpinnerSize.large} label="Please sign-in on the pop-up window." />;
    } else {
      body = <Dashboard logout={this.setLogoutstatus} isaienable={this.state.enableai} />;
    }

    return (
      <div>
        {this.state.errorMessage ? (
          <OfficeAddinMessageBar onDismiss={this.errorDismissed} message={this.state.errorMessage + " "} />
        ) : null}
        <div className="ms-welcome">{body}</div>
      </div>
    );
  }
}
